module.exports = __webpack_public_path__ + "static/media/unsupported-browser.be1694c6.svg";